import {type VariantProps} from 'class-variance-authority';
import * as React from 'react';

import {cn} from '@/utils/ui';

import {Button} from '../button';
import {alertActionVariants, alertVariants} from './alert-variants';

function Alert({
  className,
  variant,
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={cn(alertVariants({variant}), className)}
      {...props}
    />
  );
}

function AlertTitle({className, ...props}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-title"
      className={cn(
        'col-start-2 line-clamp-1 min-h-5 font-urbanist text-sm leading-5 font-medium tracking-normal',
        className
      )}
      {...props}
    />
  );
}

function AlertDescription({className, ...props}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-description"
      className={cn(
        'col-start-2 grid justify-items-start gap-1 text-sm leading-5 [&_p]:leading-relaxed',
        className
      )}
      {...props}
    />
  );
}

function AlertAction({
  className,
  variant,
  children,
  ...props
}: React.ComponentProps<'button'> & VariantProps<typeof alertActionVariants>) {
  return (
    <Button
      data-slot="alert-action"
      data-variant={variant}
      variant="secondary"
      size="small"
      className={cn(alertActionVariants({variant}), className)}
      {...props}
    >
      {variant === 'primary' ? (
        <span className="text-on-action">{children}</span>
      ) : (
        children
      )}
    </Button>
  );
}

export {Alert, AlertAction, AlertDescription, AlertTitle};
